import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const zoomIn = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1.1);
  }
`;

const SliderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
  
  @media (max-width: 768px) {
    height: 100vh;
  }
`;

const SliderList = styled.ul`
  position: relative;
  list-style: none;
  overflow: hidden;
  width: 100%;
  padding: 0;
  margin: 0;
  height: 100%;
`;

const SliderItem = styled.li`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${props => props.active ? 1 : 0};
  transition: opacity 500ms ease-in-out;
  z-index: ${props => props.active ? 2 : 1};
`;

const SliderImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  animation: ${zoomIn} 10s ease-in-out infinite;
  position: relative;
  transition: all 0.5s ease-in-out;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(26, 77, 128, 0.7) 0%,
      rgba(44, 62, 80, 0.6) 100%
    );
    z-index: 1;
  }
`;

const SliderContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

const SliderIndicators = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 3;
  
  @media (max-width: 768px) {
    bottom: 20px;
    gap: 8px;
  }
`;

const Indicator = styled.button`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid ${props => props.active ? '#f39c12' : 'rgba(255, 255, 255, 0.5)'};
  background: ${props => props.active ? '#f39c12' : 'transparent'};
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: #f39c12;
    border-color: #f39c12;
  }
  
  @media (max-width: 768px) {
    width: 10px;
    height: 10px;
  }
`;



const ImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <SliderContainer>
      <SliderList>
        {images.map((image, index) => (
          <SliderItem
            key={index}
            active={index === currentIndex}
            className={`header-wrapper ${index === currentIndex ? 'callbacks1_on' : ''}`}
            id={`callbacks1_s${index}`}
          >
            <SliderImage
              src={image.src}
              title={image.title}
              className={`slider-img${index + 1}`}
            />
            <SliderContent>
              <div className="container">
                <div className="slider_banner_info_w3ls text-center">
                  {/* Content will be overlaid by the main hero content */}
                </div>
              </div>
            </SliderContent>
          </SliderItem>
        ))}
      </SliderList>
      
      <SliderIndicators>
        {images.map((_, index) => (
          <Indicator
            key={index}
            active={index === currentIndex}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </SliderIndicators>
    </SliderContainer>
  );
};

export default ImageSlider; 